import React from 'react';
import styles from './CandidateCardAppliedSourceTag.module.scss';

export default function CandidateCardAppliedSourceTag(props) {
  const { sourceName } = props;
  let appliedTagText = 'Applied';
  if (sourceName) {
    appliedTagText =
      sourceName === 'ChatBot' ? appliedTagText.concat(' via Text Agent') : appliedTagText.concat(' via ', sourceName);
  }

  return <div className={styles.candidateCardAppliedSourceTag}>{appliedTagText}</div>;
}
